import { Suspense, lazy } from 'react'
import { useEditorStore } from '../store/editor'
import { getScene } from '../scenes'

// ScenePlayer（含 Remotion Player ~78kB gzip）懒加载：仅在预览 Remotion 场景时拉取，
// Gallery 等不触发，保持主包精简。
const ScenePlayer = lazy(() => import('../remotion/ScenePlayer'))

// 渲染当前激活场景的预览。
// - 有 Remotion Composition → <Player> 预览（更专业的动画，时钟由 Player 持有）
// - 否则回退到旧 Component（手写 rAF；map-trajectory 等无 composition 的场景）
export default function PreviewScreen() {
  const sceneId = useEditorStore((s) => s.sceneId)
  const data = useEditorStore((s) => s.data)
  const currentTime = useEditorStore((s) => s.currentTime)
  const duration = useEditorStore((s) => s.duration)
  const plugin = sceneId ? getScene(sceneId) : undefined
  if (!plugin) return null

  if (plugin.Composition) {
    return (
      <Suspense fallback={null}>
        <ScenePlayer component={plugin.Composition} data={data} duration={duration} />
      </Suspense>
    )
  }
  const C = plugin.Component
  return (
    <Suspense fallback={null}>
      <C data={data} time={currentTime} duration={duration} />
    </Suspense>
  )
}
